import buttonPresetMigration from './button-preset-migration';
import colorPaletteMigration from './color-palette-migration';

export default {
  buttonPresetMigration,
  colorPaletteMigration,
};
